<template>
  <a-select
    allowClear
    show-search
    label-in-value
    :disabled="disabled"
    :value="value"
    :filter-option="filterOption"
    style="width: 100%"
    :placeholder="$t('请输入/选择商品类目')"
    :not-found-content="loading ? undefined : null"
    @change="onChange"
    @focus="queryCategoryList"
  >
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="item in category_list" :key="item.categoryId + ''">
      {{ item.categoryName }}
    </a-select-option>
  </a-select>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
export default {
  //本地分类列表
  name: 'categoryList',
  props: ['placeholder', 'defaultValue', 'disabled'],
  data() {
    return {
      category_list: [],
      value: undefined,
      visiable: false,
      loading: false,
      modalData: {
        categoryName: '',
        categoryId: '',
      },
    }
  },
  methods: {
    clear() {
      this.value = undefined
    },
    queryCategoryList() {
      if (this.category_list.length) return
      this.loading = true
      http({
        type: 'post',
        url: api.queryCategoryList,
        data: {},
        success: (res) => {
          this.loading = false
          this.category_list = res.result.categoryList
        },
      })
    },
    onChange(value) {
      let data = null
      if (value) {
        data = {
          categoryId: value.key,
          categoryName: value.label,
        }
      } else {
        value = undefined
      }
      this.value = value
      this.$emit('handleCategoryChange', data)
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
  },
  watch: {
    defaultValue(val) {
      if (val != undefined && val != {}) {
        this.value = { key: val.categoryId, label: val.categoryName }
      } else {
        this.value = undefined
      }
    },
  },
}
</script>
